module.exports = __webpack_public_path__ + "img/C08TechTurangaChampion_ua.f578c5d3.webp";